module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 136,
	"w": 800,
	"h": 360,
	"nm": "ecom_content",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Shape Layer 1",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						400,
						180,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						95.952,
						95.952,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 13,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-34.5
													],
													[
														0,
														0
													],
													[
														0,
														31.5
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														36.5
													],
													[
														0,
														0
													],
													[
														0,
														-31.5
													]
												],
												"v": [
													[
														0,
														-60.5
													],
													[
														-10,
														-1.5
													],
													[
														0,
														61
													],
													[
														10.5,
														-1.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 14,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-34.5
													],
													[
														0,
														0
													],
													[
														0,
														12.38
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														29.118
													],
													[
														0,
														0
													],
													[
														0,
														-12.38
													]
												],
												"v": [
													[
														0,
														-28.713
													],
													[
														-2.184,
														-0.458
													],
													[
														0,
														24.524
													],
													[
														3.726,
														-1.437
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 17,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-34.5
													],
													[
														0,
														0
													],
													[
														0,
														31.5
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														36.5
													],
													[
														0,
														0
													],
													[
														0,
														-31.5
													]
												],
												"v": [
													[
														0,
														-60.5
													],
													[
														-11.042,
														-1.5
													],
													[
														0,
														61
													],
													[
														11.542,
														-1.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 24,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-52.806
													],
													[
														0,
														0
													],
													[
														0,
														60.446
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														64.178
													],
													[
														0,
														0
													],
													[
														0,
														-53.402
													]
												],
												"v": [
													[
														0,
														-104.498
													],
													[
														-31.533,
														-1.647
													],
													[
														0,
														107.795
													],
													[
														32.519,
														-1.647
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 32,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-73.727
													],
													[
														0,
														0
													],
													[
														0,
														93.528
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														89.359
													],
													[
														0,
														0
													],
													[
														0,
														-78.433
													]
												],
												"v": [
													[
														0,
														-134.683
													],
													[
														-54.95,
														-1.816
													],
													[
														0,
														130.01
													],
													[
														56.493,
														-1.816
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 40,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-98.419
													],
													[
														0,
														0
													],
													[
														0.52,
														106.312
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														103.533
													],
													[
														0,
														0
													],
													[
														-0.52,
														-97.926
													]
												],
												"v": [
													[
														0,
														-151.944
													],
													[
														-77.081,
														-1.631
													],
													[
														0,
														152.781
													],
													[
														78.226,
														-1.63
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 50,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														-0.232,
														-105.759
													],
													[
														0,
														0
													],
													[
														1.17,
														122.292
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0.266,
														121.25
													],
													[
														0,
														0
													],
													[
														-1.17,
														-122.292
													]
												],
												"v": [
													[
														0,
														-161.796
													],
													[
														-102.4,
														-1.399
													],
													[
														0,
														157.795
													],
													[
														103.049,
														-1.399
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 53,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-124.775
													],
													[
														0,
														0
													],
													[
														0,
														126.391
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														129.518
													],
													[
														0,
														0
													],
													[
														0,
														-113.311
													]
												],
												"v": [
													[
														0,
														-171.005
													],
													[
														-107.876,
														-1.33
													],
													[
														0,
														166.595
													],
													[
														110.461,
														-1.329
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.667,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 82,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-152.969
													],
													[
														0,
														0
													],
													[
														0,
														168.023
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														163.855
													],
													[
														0,
														0
													],
													[
														0,
														-155.053
													]
												],
												"v": [
													[
														0,
														-181.431
													],
													[
														-161.288,
														-1.274
													],
													[
														0,
														183.569
													],
													[
														159.704,
														-1.274
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 120,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-161.665
													],
													[
														0,
														0
													],
													[
														0,
														161.412
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														161.665
													],
													[
														0,
														0
													],
													[
														0,
														-161.412
													]
												],
												"v": [
													[
														0,
														-189.731
													],
													[
														-185.087,
														-1.958
													],
													[
														0,
														183.977
													],
													[
														185.587,
														-1.958
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									0,
									0.312775675456,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 14,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 5,
			"nm": "Your e-com  platform in  any online  content",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						400.17,
						193.149,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						45,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 42,
								"f": "LabilGrotesk-Bold",
								"t": "YOUR E-COM \u0003PLATFORM IN \u0003ANY ONLINE \u0003CONTENT",
								"j": 2,
								"tr": 0,
								"lh": 38,
								"ls": 0,
								"fc": [
									0.106,
									0.106,
									0.106
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"e": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"r": 2
						},
						"a": {
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 1
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 2
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 14,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Höger mask",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 190,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('H\\xf6ger ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.90513197955,
									0.107275996489,
									0.107275996489,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Vänster fill",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 190,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('V\\xe4nster ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"ef": [
				{
					"ty": 5,
					"nm": "Text Properties",
					"np": 4,
					"mn": "Pseudo/Bodymovin Text Props 3",
					"ix": 1,
					"en": 1,
					"ef": [
						{
							"ty": 7,
							"nm": "Vertical Text Alignment",
							"mn": "Pseudo/Bodymovin Text Props 3-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 1
							}
						},
						{
							"ty": 7,
							"nm": "Resize Behavior",
							"mn": "Pseudo/Bodymovin Text Props 3-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 2
							}
						}
					]
				}
			],
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 5,
			"nm": "Your e-com platform",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 400.17,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('V\\xe4nster ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180.862,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						2,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 42,
								"f": "LabilGrotesk-Bold",
								"t": "YOUR E-COM \u0003PLATFORM",
								"j": 2,
								"tr": 0,
								"lh": 38,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"e": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"r": 2
						},
						"a": {
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 1
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 2
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Vänster ram",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.499
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									190
								]
							},
							{
								"t": 120,
								"s": [
									400
								]
							}
						],
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Vänster mask",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 190,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('V\\xe4nster ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.90513197955,
									0.107275996489,
									0.107275996489,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Höger fill",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 610,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('H\\xf6ger ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 5,
			"nm": "Your e-com  platform in  any online  content 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 400.17,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('H\\xf6ger ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180.862,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						2,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 42,
								"f": "LabilGrotesk-Bold",
								"t": "ANY ONLINE \u0003PLATFORM",
								"j": 2,
								"tr": 0,
								"lh": 38,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"e": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"r": 2
						},
						"a": {
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 1
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 2
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 10,
			"ty": 4,
			"nm": "Höger ram",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.504
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									610
								]
							},
							{
								"t": 120,
								"s": [
									400
								]
							}
						],
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "A",
			"size": 42,
			"style": "Bold",
			"w": 75.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												57.907,
												0
											],
											[
												74.02,
												0
											],
											[
												47.635,
												-70.496
											],
											[
												28.198,
												-70.496
											],
											[
												1.712,
												0
											],
											[
												17.12,
												0
											],
											[
												23.163,
												-16.718
											],
											[
												51.865,
												-16.718
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												27.695,
												-29.205
											],
											[
												37.463,
												-56.094
											],
											[
												47.232,
												-29.205
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "A",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "N",
			"size": 42,
			"style": "Bold",
			"w": 71.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.041,
												-47.534
											],
											[
												50.354,
												0
											],
											[
												66.769,
												0
											],
											[
												66.769,
												-70.496
											],
											[
												50.958,
												-70.496
											],
											[
												51.764,
												-22.961
											],
											[
												21.451,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "N",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "Y",
			"size": 42,
			"style": "Bold",
			"w": 68.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.385,
												0
											],
											[
												42.599,
												0
											],
											[
												42.599,
												-23.969
											],
											[
												68.179,
												-70.496
											],
											[
												50.253,
												-70.496
											],
											[
												34.543,
												-41.089
											],
											[
												18.933,
												-70.496
											],
											[
												0.806,
												-70.496
											],
											[
												26.385,
												-23.969
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "Y",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": " ",
			"size": 42,
			"style": "Bold",
			"w": 17.8,
			"data": {},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "O",
			"size": 42,
			"style": "Bold",
			"w": 80.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.847,
												0
											],
											[
												0,
												20.847
											],
											[
												20.847,
												0
											],
											[
												0,
												-20.746
											]
										],
										"o": [
											[
												21.048,
												0
											],
											[
												0,
												-21.048
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												40.384,
												2.014
											],
											[
												77.646,
												-35.248
											],
											[
												40.384,
												-72.51
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												11.581,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.581,
												0
											],
											[
												0,
												-13.293
											]
										],
										"o": [
											[
												-11.783,
												0
											],
											[
												0,
												-13.495
											],
											[
												11.783,
												0
											],
											[
												0,
												13.394
											]
										],
										"v": [
											[
												40.384,
												-12.488
											],
											[
												19.537,
												-35.248
											],
											[
												40.384,
												-58.109
											],
											[
												61.23,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "O",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "L",
			"size": 42,
			"style": "Bold",
			"w": 52.5,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												49.548,
												0
											],
											[
												49.548,
												-13.193
											],
											[
												21.35,
												-13.193
											],
											[
												21.35,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "L",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "I",
			"size": 42,
			"style": "Bold",
			"w": 27.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.841,
												0
											],
											[
												21.954,
												0
											],
											[
												21.954,
												-70.496
											],
											[
												5.841,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "I",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "E",
			"size": 42,
			"style": "Bold",
			"w": 58.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												55.087,
												0
											],
											[
												55.087,
												-12.891
											],
											[
												21.35,
												-12.891
											],
											[
												21.35,
												-29.608
											],
											[
												51.059,
												-29.608
											],
											[
												51.059,
												-41.592
											],
											[
												21.35,
												-41.592
											],
											[
												21.35,
												-57.806
											],
											[
												54.684,
												-57.806
											],
											[
												54.684,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "E",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "\u0003",
			"size": 42,
			"style": "Bold",
			"w": 0,
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "P",
			"size": 42,
			"style": "Bold",
			"w": 62,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												13.293
											],
											[
												15.005,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												15.005,
												0
											],
											[
												0,
												-13.293
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.35,
												0
											],
											[
												21.35,
												-23.264
											],
											[
												34.442,
												-23.264
											],
											[
												59.921,
												-46.93
											],
											[
												34.442,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-6.345
											],
											[
												6.345,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.345,
												0
											],
											[
												0,
												6.345
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.35,
												-36.154
											],
											[
												21.35,
												-57.605
											],
											[
												32.73,
												-57.605
											],
											[
												43.506,
												-46.93
											],
											[
												32.73,
												-36.154
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "P",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "T",
			"size": 42,
			"style": "Bold",
			"w": 60,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												22.055,
												0
											],
											[
												38.37,
												0
											],
											[
												38.37,
												-57.605
											],
											[
												58.109,
												-57.605
											],
											[
												58.109,
												-70.496
											],
											[
												2.316,
												-70.496
											],
											[
												2.316,
												-57.605
											],
											[
												22.055,
												-57.605
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "T",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "F",
			"size": 42,
			"style": "Bold",
			"w": 54.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.35,
												0
											],
											[
												21.35,
												-27.997
											],
											[
												50.354,
												-27.997
											],
											[
												50.354,
												-40.485
											],
											[
												21.35,
												-40.485
											],
											[
												21.35,
												-57.605
											],
											[
												52.368,
												-57.605
											],
											[
												52.368,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "F",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "R",
			"size": 42,
			"style": "Bold",
			"w": 64.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.403,
												-6.143
											],
											[
												0,
												0
											],
											[
												-0.604,
												-1.611
											],
											[
												0,
												0
											],
											[
												0.201,
												3.323
											],
											[
												0,
												0
											],
											[
												9.567,
												0.705
											],
											[
												0,
												9.467
											],
											[
												15.61,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.345,
												0
											],
											[
												0,
												0
											],
											[
												0.201,
												2.115
											],
											[
												0,
												0
											],
											[
												-0.806,
												-1.813
											],
											[
												0,
												0
											],
											[
												-0.504,
												-8.56
											],
											[
												10.776,
												-1.108
											],
											[
												0,
												-12.689
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.149,
												0
											],
											[
												21.149,
												-23.566
											],
											[
												32.529,
												-23.566
											],
											[
												42.599,
												-15.408
											],
											[
												43.204,
												-5.942
											],
											[
												44.312,
												0
											],
											[
												60.626,
												0
											],
											[
												59.317,
												-7.15
											],
											[
												58.713,
												-16.617
											],
											[
												44.211,
												-31.018
											],
											[
												62.64,
												-49.045
											],
											[
												36.154,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-6.345
											],
											[
												6.546,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												6.445,
												0
											],
											[
												0,
												6.244
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.149,
												-36.255
											],
											[
												21.149,
												-57.605
											],
											[
												35.349,
												-57.605
											],
											[
												46.326,
												-46.93
											],
											[
												35.147,
												-36.255
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "R",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "M",
			"size": 42,
			"style": "Bold",
			"w": 88.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.746,
												0
											],
											[
												19.739,
												-50.253
											],
											[
												36.255,
												0
											],
											[
												52.57,
												0
											],
											[
												69.186,
												-50.253
											],
											[
												68.179,
												0
											],
											[
												83.89,
												0
											],
											[
												83.89,
												-70.496
											],
											[
												61.533,
												-70.496
											],
											[
												44.513,
												-16.315
											],
											[
												27.594,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "M",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "U",
			"size": 42,
			"style": "Bold",
			"w": 69,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-18.228,
												0
											],
											[
												0,
												17.624
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												8.862,
												0
											],
											[
												0,
												9.668
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												18.228,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.668
											],
											[
												-8.862,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												17.624
											]
										],
										"v": [
											[
												34.744,
												1.41
											],
											[
												65.46,
												-28.198
											],
											[
												65.46,
												-70.496
											],
											[
												49.146,
												-70.496
											],
											[
												49.146,
												-28.702
											],
											[
												34.744,
												-13.092
											],
											[
												20.343,
												-28.702
											],
											[
												20.343,
												-38.672
											],
											[
												20.343,
												-70.496
											],
											[
												4.028,
												-70.496
											],
											[
												4.028,
												-38.672
											],
											[
												4.028,
												-28.198
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "U",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "-",
			"size": 42,
			"style": "Bold",
			"w": 38.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												34.14,
												-36.456
											],
											[
												2.518,
												-30.917
											],
											[
												4.431,
												-19.94
											],
											[
												36.053,
												-25.479
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "-",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "-",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "C",
			"size": 42,
			"style": "Bold",
			"w": 77.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.645,
												0
											],
											[
												-0.201,
												16.818
											],
											[
												0,
												0
											],
											[
												10.373,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.884,
												0
											],
											[
												-0.403,
												-9.467
											],
											[
												0,
												0
											],
											[
												19.135,
												0
											],
											[
												0,
												-20.847
											]
										],
										"o": [
											[
												19.235,
												0
											],
											[
												0,
												0
											],
											[
												-0.604,
												9.869
											],
											[
												-12.085,
												0
											],
											[
												0,
												-13.495
											],
											[
												10.675,
												0
											],
											[
												0,
												0
											],
											[
												-0.302,
												-16.617
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												39.981,
												1.913
											],
											[
												74.524,
												-27.997
											],
											[
												58.813,
												-29.205
											],
											[
												39.981,
												-12.589
											],
											[
												19.537,
												-35.248
											],
											[
												39.981,
												-58.109
											],
											[
												58.813,
												-41.895
											],
											[
												74.625,
												-43.204
											],
											[
												39.981,
												-72.409
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "C",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/ecom_content.json
// module id = 73
// module chunks = 0